<template>
  <div>
    <el-tooltip :content="$t('accountProfileDetails.cardReplace.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button icon round type="primary" @click="modal = true" class="text-nowrap zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-file-replace"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountProfileDetails.cardReplace.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountProfileDetails.cardReplace.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.cardReplace.form.publicId')
              }}</label>
            <div class="col-md-9">
              <base-input
                type="text"
                name="public_id"
                :error="getError('public_id')"
                :placeholder="$t('accountProfileDetails.cardReplace.form.publicIdPlaceholder')"
                v-model="formDetails.public_id">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.cardReplace.form.serialNumber')
              }}</label>
            <div class="col-md-9">
              <base-input
                type="text"
                name="serial_number"
                :error="getError('serial_number')"
                :placeholder="$t('accountProfileDetails.cardReplace.form.serialNumberPlaceholder')"
                v-model="formDetails.serial_number">
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountProfileDetails.cardReplace.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'accountCardReplaceBtn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        public_id: '',
        serial_number: ''
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account.updating,
      error: state => state.account.error,
      data: state => state.account.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['LoadCard', 'ListAccountPosOperations', 'AccountCardReplace', 'LoadAccountAuditLogs']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.AccountCardReplace({id: this.accountId, data: this.formDetails}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.LoadCard({id: this.accountId, byAccountId: true})
          this.ListAccountPosOperations(this.accountId)
          this.LoadAccountAuditLogs({id: this.accountId, query: {id: "", filter: "", action_result:""}})
          this.$notify({
            type: 'success',
            message: this.$t('accountProfileDetails.cardReplace.createdNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        public_id: '',
        serial_number: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
  mounted() {
  },
}
</script>
